import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "100%",
        y2: "0%"
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": "#1267EF"
        }),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": "#0BEADE"
        })
      ])
    ], -1),
    _createElementVNode("path", {
      fill: "url(#a)",
      "fill-rule": "nonzero",
      d: "M12.155 0H1.846a.97.97 0 0 0-.971.97L0 13.03c0 .536.435.971.971.971H13.03a.97.97 0 0 0 .97-.97L13.125.97a.97.97 0 0 0-.97-.971M10.96 4.807a3.936 3.936 0 0 1-3.925 3.82 3.934 3.934 0 0 1-3.924-3.804.779.779 0 0 1 .342-1.482c.433 0 .784.35.784.784a.78.78 0 0 1-.263.576 3.066 3.066 0 0 0 3.062 3.052 3.064 3.064 0 0 0 3.06-3.038.77.77 0 0 1-.283-.59.784.784 0 1 1 1.568 0 .78.78 0 0 1-.42.682"
    }, null, -1)
  ])))
}
export default { render: render }